const profiles = {
    SYSTEM_ADMINISTRATOR: 1,
    FINANCIAL_ADVISOR: 2,
    STANDARD_USER: 3,
    CLIENT: 4,
    MANAGER: 5,
}
export default profiles;
